import React from "react";
import Deadline from "./Deadline";
import TranslatorProfiles from "./TranslatorProfiles";

export default function StepTwo() {
  return (
    <div className="step">
      <Deadline />
      <br /> <br />
      <TranslatorProfiles />
    </div>
  );
}
